import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'visitor'

const client = new ApiClient(API_NAME)

export default {
  show(visitor_id, history_id) {
    return client.get(`/${BASE_PATH}/${visitor_id}/history/${history_id}/`)
  },
  create(visitorId, data) {
    let dataCopy = {...data}
    if (dataCopy.count_of_people == 0) {
      delete dataCopy.count_of_people
    }
    if (dataCopy.bill_amount == null || dataCopy.bill_amount === '') {
      delete dataCopy.bill_amount
    }
    if (dataCopy.use_purpose_id == 0) {
      delete dataCopy.use_purpose_id
    }
    return client.post(`/${BASE_PATH}/${visitorId}`, dataCopy)
  },
  update(visitorId, historyId, data) {
    data.revision = data.revision * 1
    let dataCopy = {...data}
    if (dataCopy.count_of_people == 0) {
      delete dataCopy.count_of_people
    }
    if (dataCopy.bill_amount == null || dataCopy.bill_amount === '') {
      delete dataCopy.bill_amount
    }
    if (dataCopy.use_purpose_id == 0) {
      delete dataCopy.use_purpose_id
    }
    return client.put(`/${BASE_PATH}/${visitorId}/history/${historyId}`, dataCopy)
  }
}
